import { CodeNext, RenderMedia } from "@fusion-advantage/backcompat"
import { useFormSelector } from "../../../redux/formStoreHooks"
import { selectExport } from "../../../redux/selectForm"
import L1ErrorBlock from "../l1/L1ErrorBlock"

export enum ConditionalDisplayRule {
	CollaboratingPhysicianSignature = "collaboratingPhysicianSignature",
}

interface L4ConditionalDisplayProps {
	cid?: string
	rule: string
	children: React.ReactNode
}

const L4ConditionalDisplay = ({cid, rule, children}: L4ConditionalDisplayProps) => {
	const exp = useFormSelector(selectExport)
	const media = useFormSelector(state => state.render.media)
	if(!exp) {
		return <L1ErrorBlock content={`[L4ConditionalDisplay ${cid}] expected exp but null`} />
	}
	const codeNext = exp.Form.Encounter.CodeNext
	switch(rule) {
		case ConditionalDisplayRule.CollaboratingPhysicianSignature:
			// show on print = always (if valued)
			// show on screen = only during a collab physician codenext
			if(
				media === RenderMedia.Print ||
				codeNext === CodeNext.CollaboratingPhysicianPending ||
				codeNext === CodeNext.CollaboratingPhysicianSubmitted
			) {
				return children
			}
			return null
		default:
			return <L1ErrorBlock content={`[L4ConditionalDisplay ${cid}] unknown rule '${rule}' specified`} />
	}
}

export default L4ConditionalDisplay